/** Original Tavi's Workshop pixel art. Legacy keys preserve saved-course compatibility. */
import { parseSprite, type Sprite } from '../sprite'
export const CHARACTER_SPRITES: Record<string, Sprite> = {
  'tavi-small-idle': parseSprite(
    16,
    `
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK...
...KKKKKKKKKK...
....KKKKKKKKN...
...NKMYWYYMK.N..
..N.KMYYYYMK..T.
.T..KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
...KKKK..KKKK...
`,
  ),
  'tavi-small-walk1': parseSprite(
    16,
    `
....Y...........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKK...
...KGKBBBWWWK...
...KGKBBBBBBK...
...KGKKKKKKKK...
...KKKKKKKKKK...
.TN.KKKKKKKK....
..N.KNYYYYMKN...
..KNNKKaKKwKKNTN
.....Ka...Kw.KN.
..KNNN.....Kw...
..KKKK.....Kw...
..........KOOO..
..........KKKK..
`,
  ),
  'tavi-small-walk2': parseSprite(
    16,
    `
....Y...........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKK...
...KGKBBBWWWK...
...KGKBBBBBBK...
...KGKKKKKKKK...
...KKKKKKKKKK...
....KKKKKKKK....
....KNYYYYMKN...
..KNNKKaKKwwKKN.
...TN.K.a..KKw..
.......Ka...w...
.......Ka.KOOO..
......KNNNKKKK..
......KKKK......
`,
  ),
  'tavi-small-walk3': parseSprite(
    16,
    `
....Y...........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKK...
...KGKBBBWWWK...
...KGKBBBBBBK...
...KGKKKKKKKK...
...KKKKKKKKKKTN.
....KKKKKKKK.KKN
...KNNYYYYMKNN..
.KNNKKKwKKaK....
..TN.Kw...Kaa...
....Kw....KNNN..
....Kw....KKKK..
...KOOO.........
...KKKK.........
`,
  ),
  'tavi-small-jump': parseSprite(
    16,
    `
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK.T.
...KKKKKKKKKKN..
.T..KKKKKKKKN...
..NNKMYWYYMK....
....KMYYYYMK....
....KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
...KKKK..KKKK...
`,
  ),
  'tavi-small-skid': parseSprite(
    16,
    `
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK...
...KKKKKKKKKK...
....KKKKKKKKN...
...NKMYWYYMK.N..
..N.KMYYYYMK..T.
.T..KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
.TTTTTT..KKKK...
`,
  ),
  'tavi-big-idle': parseSprite(
    16,
    `
....YYY.........
....YYY.........
.....N..........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK...
...KKKKKKKKKK...
....KKKKKKKKN...
...NKMYWYYMK.N..
..N.KMYYYYMK..T.
.T..KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
...KKKK..KKKK...
`,
  ),
  'tavi-big-walk1': parseSprite(
    16,
    `
................
....Y...........
....N...........
....N...........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKK...
...KGKBBBWWWK...
...KGKBBBBBBK...
...KGKKKKKKKK...
...KKKKKKKKKK...
.TN.KKKKKKKK....
..N.KNYYYYMKN...
..KNNMYWWYMKKNTN
....KMYWWYMK.KN.
....KMYWWYMK....
....KMYWWYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KKKaKKwK....
.....Ka...Kw....
.....Ka...Kw....
....Ka.....Kw...
....a......Kw...
..KNNN.....Kw...
..KKKK.....Kw...
..........KOOO..
..........KKKK..
`,
  ),
  'tavi-big-walk2': parseSprite(
    16,
    `
................
....Y...........
....N...........
....N...........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKK...
...KGKBBBWWWK...
...KGKBBBBBBK...
...KGKKKKKKKK...
...KKKKKKKKKK...
....KKKKKKKK....
....KNYYYYMKN...
..KNNMYWWYMKKKN.
...TNMYWWYMKTN..
....KMYWWYMK....
....KMYWWYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KKKaKKwK....
......Ka..Kww...
.......Ka...Kw..
.......Ka...w...
.......Ka.KOOO..
.......Ka.KKKK..
.......Ka.......
......KNNN......
......KKKK......
`,
  ),
  'tavi-big-walk3': parseSprite(
    16,
    `
................
....Y...........
....N...........
....N...........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKK...
...KGKBBBWWWK...
...KGKBBBBBBK...
...KGKKKKKKKK...
...KKKKKKKKKKTN.
....KKKKKKKK.KKN
...KNNYYYYMKNN..
.KNNKMYWWYMK....
..TNKMYWWYMK....
....KMYWWYMK....
....KMYWWYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KKKwKKaK....
.....Kw...Ka....
.....Kw....Ka...
....Kw......Ka..
....Kw......a...
....Kw....KNNN..
....Kw....KKKK..
...KOOO.........
...KKKK.........
`,
  ),
  'tavi-big-jump': parseSprite(
    16,
    `
....YYY.........
....YYY.........
.....N..........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK.T.
...KKKKKKKKKKN..
.TN.KKKKKKKKN...
...NKMYWYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
...KKKK..KKKK...
`,
  ),
  'tavi-big-skid': parseSprite(
    16,
    `
....YYY.........
....YYY.........
.....N..........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK...
...KKKKKKKKKK...
....KKKKKKKKN...
...NKMYWYYMK.N..
..N.KMYYYYMK..T.
.T..KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KMYYYYMK....
....KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
.TTTTTT..KKKK...
`,
  ),
  'tavi-big-duck': parseSprite(
    16,
    `
................
................
................
................
................
................
................
................
................
................
................
................
................
....YYY.........
....YYY.........
.....N..........
.....N..........
...KTTTTTTTTK...
...KGGGGGGGGK...
...KGKKKKKKKKK..
...KGKBBBWWWBK..
...KGKBBBBBBBK..
...KGKKKKKKKKK..
...KGGGGGGGGK...
...KKKKKKKKKK...
....KKKKKKKKN...
...NKMYWYYMK.N..
..N.KMYYYYMK..T.
.T..KKKKKKKK....
...KKKK..KKKK...
...KNNK..KNNK...
...KKKK..KKKK...
`,
  ),
  'shield-tavi': parseSprite(
    16,
    `
................
........K.......
........K.......
........p.......
.......KpK......
.......KpK......
......KpppK.....
......KpppK.....
.....KKpppKK....
.....KpppppK....
....KKpppppKK...
....KpppppppK...
...KKpppWpppKK..
...KKpppWpppKK..
..KKpppWWWpppKK.
..KKpppWWWpppKK.
.KKpppWWWWWpppKK
..KKpppWWWpppKK.
..KKpppWWWpppKK.
...KKpppWpppKK..
...KKpppWpppKK..
....KpppppppK...
....KKpppppKK...
.....KpppppK....
.....KKpppKK....
......KpppK.....
......KpppK.....
.......KpK......
.......KpK......
........p.......
........K.......
........K.......
`,
  ),
  'rivet-walk1': parseSprite(
    16,
    `
....Y...........
....Y...........
....Y...........
...KYKKKKKKKK...
...KOOOOOOOOK...
...KOOOOOOOOK...
...KNNNKKKKKK...
...KNNNKTWTKK...
...KNNNKTTTKK...
...KNNNKKKKKK...
...KKKaKKKKwK...
....Ka....Kw....
.KNNN......Kw...
.KKKK......Kw...
...........KOOO.
...........KKKK.
`,
  ),
  'rivet-walk2': parseSprite(
    16,
    `
....Y...........
....Y...........
....Y...........
...KYKKKKKKKK...
...KOOOOOOOOK...
...KOOOOOOOOK...
...KNNNKKKKKK...
...KNNNKTWTKK...
...KNNNKTTTKK...
...KNNNKKKKKK...
...KKKaKKKKww...
......Ka....Kw..
.......Ka..KOOO.
.......Ka..KKKK.
......KNNN......
......KKKK......
`,
  ),
  'rivet-flat': parseSprite(
    16,
    `
................
................
................
................
................
................
................
................
................
................
................
................
..KKKKKKKKKKKK..
..KNTTTTNNNNNK..
..KNNNNNTTTTNK..
..KKKKKKKKKKKK..
`,
  ),
  'scout-walk1': parseSprite(
    16,
    `
.........KKKKKK.
.........KTTWTK.
.........KKKKKK.
.........N......
........KN......
.....KKKVKKK....
...KKKVVTVVKKK..
...KKVVTTTVVKK..
..KKVVTTTTTVVKK.
...KKVVTTTVVKK..
...KKKaVTVKwKK..
....KaKKVKKw....
.KNNN...K..Kw...
.KKKK......Kw...
...........KOOO.
...........KKKK.
`,
  ),
  'scout-walk2': parseSprite(
    16,
    `
.........KKKKKK.
.........KTTWTK.
.........KKKKKK.
.........N......
........KN......
.....KKKVKKK....
...KKKVVTVVKKK..
...KKVVTTTVVKK..
..KKVVTTTTTVVKK.
...KKVVTTTVVKK..
...KKKaVTVKwwK..
.....KKaVKKKKw..
.......Ka..KOOO.
.......Ka..KKKK.
......KNNN......
......KKKK......
`,
  ),
  'scout-wheel': parseSprite(
    16,
    `
................
................
................
................
................
........K.......
....KKKKVKKKK...
...KKVVVVVVVKK..
..KKVVVVTVVVVKK.
..KKVVVTTTVVVKK.
.KKVVVTTTTTVVVKK
..KKVVVTTTVVVKK.
..KKVVVVTVVVVKK.
...KKVVVVVVVKK..
...KKKKKKKKWK...
...KKKKKKKKKK...
`,
  ),
  'shardling-walk1': parseSprite(
    16,
    `
................
...K...K...K....
...K...K...K....
...p...p...p....
..KpK.KpK.KpK...
..KpK.KpK.KpK...
.KpppKpppKpppK..
..KpKKKpKKKpKK..
..KpKVKpKVKpKK..
..KpVVVpVVVpWK..
..KKVKaKVVKwVK..
..KKKaKKKKKwKK..
.KNNN......Kw...
.KKKK......Kw...
...........KOOO.
...........KKKK.
`,
  ),
  'shardling-walk2': parseSprite(
    16,
    `
................
...K...K...K....
...K...K...K....
...p...p...p....
..KpK.KpK.KpK...
..KpK.KpK.KpK...
.KpppKpppKpppK..
..KpKKKpKKKpKK..
..KpKVKpKVKpKK..
..KpVVVpVVVpWK..
..KKVKaKVVKwwK..
..KKKKKaKKKKKw..
.......Ka..KOOO.
.......Ka..KKKK.
......KNNN......
......KKKK......
`,
  ),
  wisp: parseSprite(
    16,
    `
................
................
........K.......
.p.....KKK....p.
..pp..KKVKK.pp..
....pKKVVVKp....
....KKVVTVVKK...
...KKVTTTWTVKK..
.KKVVTTTTTTTVVKK
...KKVTTTTTVKK..
....KKVVTVVKK...
.....KKVVVKK....
......KKVKK.....
.......KKK......
......TTTTT.....
................
`,
  ),
  'expansion-cell': parseSprite(
    16,
    `
................
.....KKKKKK.....
.....KNNNNK.....
.....KKKKKK.....
...KKKKKKKKKK...
...KaNNNNNNaK...
...KaNTTTTNaK...
..NKaNWWWWNaKN..
..NKaNWWWWNaKN..
..NKaNWWWWNaKN..
..NKaNWWWWNaKN..
..NKaNTTTTNaKN..
...KaNNNNNNaK...
...KaaaaaaaaK...
...KKKKKKKKKK...
................
`,
  ),
  'spare-battery': parseSprite(
    16,
    `
................
.....KKKKKK.....
.....KNNNNK.....
.....KKKKKK.....
...KKKKKKKKKK...
...KaNNNNNNaK...
...KaNgWWgNaK...
..NKaNgWWgNaKN..
..NKaWWWWWWaKN..
..NKaWWWWWWaKN..
..NKaNgWWgNaKN..
..NKaNgWWgNaKN..
...KaNNNNNNaK...
...KaaaaaaaaK...
...KKKKKKKKKK...
................
`,
  ),
  'ember-cell': parseSprite(
    16,
    `
................
.....KKKKKK.....
.....KNNNNK.....
.....KKKKKK.....
...KKKKKKKKKK...
...KaNNNNNNaK...
...KaNOOOWNaK...
..NKaNOOWONaKN..
..NKaNOWOONaKN..
..NKaNWWWWNaKN..
..NKaNOOWONaKN..
..NKaNOWOONaKN..
...KaNWNNNNaK...
...KaaaaaaaaK...
...KKKKKKKKKK...
................
`,
  ),
  prism: parseSprite(
    16,
    `
................
........K.......
.......KKK......
......KKpKK.....
.....KKpWpKK....
....KKppWppKK...
...KKppWWWppKK..
..KKpppWWWpppKK.
.KKpppWWWWWpppKK
..KKpppWWWpppKK.
...KKppWWWppKK..
....KKppWppKK...
.....KKpWpKK....
......KKpKK.....
.......KKK......
........K.......
`,
  ),
  coin: parseSprite(
    16,
    `
................
........K.......
........K.......
.......KWK......
......KTWTK.....
.....KTTWTTK....
....KTTTWTTTK...
...KTTTTWTTTTK..
..KTTTTTWTTTTTK.
...KTTTTWTTTTK..
....KTTTWTTTK...
.....KTTWTTK....
......KTTTK.....
.......KTK......
........K.......
........K.......
`,
  ),
  'coin-frame2': parseSprite(
    16,
    `
................
........K.......
........K.......
.......KWK......
.......KWK......
......KTWTK.....
......KTWTK.....
.....KTTWTTK....
....KTTTWTTTK...
.....KTTWTTK....
......KTWTK.....
......KTWTK.....
.......KTK......
.......KTK......
........K.......
........K.......
`,
  ),
  'coin-frame3': parseSprite(
    16,
    `
................
........K.......
........K.......
........W.......
........W.......
.......KWK......
.......KWK......
.......KWK......
......KTWTK.....
.......KWK......
.......KWK......
.......KWK......
........T.......
........T.......
........K.......
........K.......
`,
  ),
  fireball: parseSprite(
    8,
    `
........
........
........
........
.......O
......OO
....OOOO
...OOOOY
`,
  ),
  'tavi-small-run1': parseSprite(
    16,
    `
.....Y..........
....KTTTTTTTTK..
....KGGGGGGGGK..
....KGKKKKKKKK..
....KGKBBBWWWK..
....KGKBBBBBBK..
....KGKKKKKKKK..
....KKKKKKKKKK..
.TN..KKKKKKKK...
..N.KNNYYYYMKN..
..KNNKKaKKwKK.TN
.....Ka...Kw.KN.
.KNNNa.....Kw...
.KKKK.......w...
...........KOOO.
...........KKKK.
`,
  ),
  'tavi-small-run2': parseSprite(
    16,
    `
.....Y..........
....KTTTTTTTTK..
....KGGGGGGGGK..
....KGKKKKKKKK..
....KGKBBBWWWK..
....KGKBBBBBBK..
....KGKKKKKKKK..
....KKKKKKKKKK..
.....KKKKKKKK...
....KNNYYYYMKN..
..KNNKKaKKwwKKN.
...TN.K.a..KKw..
.......Ka...w...
.......Ka.KOOO..
......KNNNKKKK..
......KKKK......
`,
  ),
  'tavi-small-run3': parseSprite(
    16,
    `
.....Y..........
....KTTTTTTTTK..
....KGGGGGGGGK..
....KGKKKKKKKK..
....KGKBBBWWWK..
....KGKBBBBBBK..
....KGKKKKKKKK..
....KKKKKKKKKTN.
.....KKKKKKKKKKN
....KNNYYYYMKN..
.KNNNKKwKKaKK...
..TN.Kw...Kaa...
....Kw......KNNN
....w.......KKKK
..KOOO..........
..KKKK..........
`,
  ),
  'tavi-big-run1': parseSprite(
    16,
    `
................
.....Y..........
.....N..........
......N.........
......N.........
....KTTTTTTTTK..
....KGGGGGGGGK..
....KGKKKKKKKK..
....KGKBBBWWWK..
....KGKBBBBBBK..
....KGKKKKKKKK..
....KKKKKKKKKK..
.TN..KKKKKKKK...
..N.KNNYYYYMKN..
..KNNKMYWWYMK.TN
.....KMYWWYMKKN.
.....KMYWWYMK...
.....KMYWWYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KKaKKwKK...
.....Ka...Kw....
.....Ka...Kw....
....Ka.....Kw...
...Ka......Kw...
.KNNN.......w...
.KKKK.......Kw..
...........KOOO.
...........KKKK.
`,
  ),
  'tavi-big-run2': parseSprite(
    16,
    `
................
.....Y..........
.....N..........
......N.........
......N.........
....KTTTTTTTTK..
....KGGGGGGGGK..
....KGKKKKKKKK..
....KGKBBBWWWK..
....KGKBBBBBBK..
....KGKKKKKKKK..
....KKKKKKKKKK..
.....KKKKKKKK...
....KNNYYYYMKN..
..KNNKMYWWYMKKN.
...TNKMYWWYMTN..
.....KMYWWYMK...
.....KMYWWYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KKaKKwKK...
......Ka..Kww...
.......Ka...Kw..
.......Ka...w...
.......Ka.KOOO..
.......Ka.KKKK..
.......Ka.......
......KNNN......
......KKKK......
`,
  ),
  'tavi-big-run3': parseSprite(
    16,
    `
................
.....Y..........
.....N..........
......N.........
......N.........
....KTTTTTTTTK..
....KGGGGGGGGK..
....KGKKKKKKKK..
....KGKBBBWWWK..
....KGKBBBBBBK..
....KGKKKKKKKK..
....KKKKKKKKKTN.
.....KKKKKKKKKKN
....KNNYYYYMKN..
.KNNNKMYWWYMK...
..TN.KMYWWYMK...
.....KMYWWYMK...
.....KMYWWYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KMYYYYMK...
.....KKwKKaKK...
.....Kw...Ka....
.....Kw....Ka...
....Kw......Ka..
....Kw......K.a.
....w.......KNNN
...Kw.......KKKK
..KOOO..........
..KKKK..........
`,
  ),
  'rivet-walk3': parseSprite(
    16,
    `
....Y...........
....Y...........
....Y...........
...KYKKKKKKKK...
...KOOOOOOOOK...
...KOOOOOOOOK...
...KNNNKKKKKK...
...KNNNKTWTKK...
...KNNNKTTTKK...
...KNNNKKKKKK...
...KKKwKKKKaK...
.....Kw....Ka...
....Kw......KNNN
....Kw......KKKK
..KOOO..........
..KKKK..........
`,
  ),
  'scout-walk3': parseSprite(
    16,
    `
.........KKKKKK.
.........KTTWTK.
.........KKKKKK.
.........N......
........KN......
.....KKKVKKK....
...KKKVVTVVKKK..
...KKVVTTTVVKK..
..KKVVTTTTTVVKK.
...KKVVTTTVVKK..
...KKKwVTVKaKK..
.....KwKVKKKa...
....Kw..K...KNNN
....Kw......KKKK
..KOOO..........
..KKKK..........
`,
  ),
  'shardling-walk3': parseSprite(
    16,
    `
................
...K...K...K....
...K...K...K....
...p...p...p....
..KpK.KpK.KpK...
..KpK.KpK.KpK...
.KpppKpppKpppK..
..KpKKKpKKKpKK..
..KpKVKpKVKpKK..
..KpVVVpVVVpWK..
..KKVKwKVVKaVK..
..KKKKwKKKKKaK..
....Kw......KNNN
....Kw......KKKK
..KOOO..........
..KKKK..........
`,
  ),
}
